__turbopack_context__.v({
  "UiArtworkSelect__list": "framing-module__84tj0q__UiArtworkSelect__list",
  "UiArtworkSelect__option": "framing-module__84tj0q__UiArtworkSelect__option",
  "UiArtworkSelect__optionThumb": "framing-module__84tj0q__UiArtworkSelect__optionThumb",
  "UiArtworkSelect__thumb": "framing-module__84tj0q__UiArtworkSelect__thumb",
  "UiArtworkSelect__trigger": "framing-module__84tj0q__UiArtworkSelect__trigger",
  "UiFrameContent": "framing-module__84tj0q__UiFrameContent",
  "UiFrameContent__arrow": "framing-module__84tj0q__UiFrameContent__arrow",
  "UiFrameContent__cta": "framing-module__84tj0q__UiFrameContent__cta",
  "UiFrameContent__item": "framing-module__84tj0q__UiFrameContent__item",
  "UiFrameDrawer": "framing-module__84tj0q__UiFrameDrawer",
  "UiFrameDrawer__actions": "framing-module__84tj0q__UiFrameDrawer__actions",
  "UiFrameDrawer__artwork": "framing-module__84tj0q__UiFrameDrawer__artwork",
  "UiFrameDrawer__artworkDesktop": "framing-module__84tj0q__UiFrameDrawer__artworkDesktop",
  "UiFrameDrawer__body": "framing-module__84tj0q__UiFrameDrawer__body",
  "UiFrameDrawer__close": "framing-module__84tj0q__UiFrameDrawer__close",
  "UiFrameDrawer__footer": "framing-module__84tj0q__UiFrameDrawer__footer",
  "UiFrameDrawer__footerInner": "framing-module__84tj0q__UiFrameDrawer__footerInner",
  "UiFrameDrawer__group": "framing-module__84tj0q__UiFrameDrawer__group",
  "UiFrameDrawer__groups": "framing-module__84tj0q__UiFrameDrawer__groups",
  "UiFrameDrawer__guideItem": "framing-module__84tj0q__UiFrameDrawer__guideItem",
  "UiFrameDrawer__header": "framing-module__84tj0q__UiFrameDrawer__header",
  "UiFrameDrawer__panel": "framing-module__84tj0q__UiFrameDrawer__panel",
  "UiFrameDrawer__preview": "framing-module__84tj0q__UiFrameDrawer__preview",
  "UiFrameDrawer__previewArea": "framing-module__84tj0q__UiFrameDrawer__previewArea",
  "UiFrameDrawer__previewImage": "framing-module__84tj0q__UiFrameDrawer__previewImage",
  "UiFrameDrawer__previewToggle": "framing-module__84tj0q__UiFrameDrawer__previewToggle",
  "UiFrameDrawer__secondary": "framing-module__84tj0q__UiFrameDrawer__secondary",
  "UiFrameDrawer__sheet": "framing-module__84tj0q__UiFrameDrawer__sheet",
  "UiFrameDrawer__tabs": "framing-module__84tj0q__UiFrameDrawer__tabs",
  "UiFrameDrawer__title": "framing-module__84tj0q__UiFrameDrawer__title",
  "UiFrameTabs": "framing-module__84tj0q__UiFrameTabs",
  "UiFrameTabs__tab": "framing-module__84tj0q__UiFrameTabs__tab",
});
